export default __webpack_public_path__ + "static/media/tree-num-four.5cc3dde6.png";